import { StockOrderItem } from "@towersystems/roam-common/lib/generated-types";
import { OrderItemFormValues } from "../components/OrderItemForm/types";

export const stockOrderItemToFormValues = (
  item: StockOrderItem
): OrderItemFormValues => {
  return {
    id: item.id,
    productId: item.productId ?? "",
    quantity: item.quantity.toString(),
    stockOrderId: item.stockOrderId ?? "",
    supplierCode: item.product?.supplierStockCode ?? "",
    supplierId: item.product?.supplierId ?? undefined,
    name: item.product?.name ?? item.name ?? "",
    barcode: item.barcode ?? "",
  };
};
